export const NAME = 'resetpassword';

// User password reset initialize procedure constants
export const REQUEST_PASSWORD_RESET_INIT = 'REQUEST_PASSWORD_RESET_INIT';
export const SUCCESS_PASSWORD_RESET_INIT = 'SUCCESS_PASSWORD_RESET_INIT';
export const FAILURE_PASSWORD_RESET_INIT = 'FAILURE_PASSWORD_RESET_INIT';

// User password reset start procedure constants
export const REQUEST_PASSWORD_RESET_COMMIT = 'REQUEST_PASSWORD_RESET_COMMIT';
export const SUCCESS_PASSWORD_RESET_COMMIT = 'SUCCESS_PASSWORD_RESET_COMMIT';
export const FAILURE_PASSWORD_RESET_COMMIT = 'FAILURE_PASSWORD_RESET_COMMIT';



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/constants.js